import type {CustomerInsightsRecord} from '../types/CustomerInsightsViewModel';
import {sortCustomerInsightsRecordsByOccurredAt} from './sortCustomerInsightsRecordsByOccurredAt';

const CUSTOMER_INSIGHTS_OPEN_RECORD_LIMIT = 5;

export const getNewestCustomerInsightsRecords = (records: CustomerInsightsRecord[]) =>
  sortCustomerInsightsRecordsByOccurredAt(records).slice(0, CUSTOMER_INSIGHTS_OPEN_RECORD_LIMIT);
